import { action } from 'satcheljs';

export interface UpdateCopilotChatDrawerPinnedPaneMessage {
    // Whether the action is for saving or removing Copilot Chat Drawer as the pinned pane.
    isSavingAsCopilotChatDrawer: boolean;
}
export const updateCopilotChatDrawerPinnedPaneAction: (
    isSavingAsCopilotChatDrawer: boolean
) => UpdateCopilotChatDrawerPinnedPaneMessage = action(
    'updateCopilotChatDrawerPinnedPaneAction',
    (isSavingAsCopilotChatDrawer: boolean): UpdateCopilotChatDrawerPinnedPaneMessage => ({
        isSavingAsCopilotChatDrawer,
    })
);
